import { Component, Vue, Prop, PropSync } from 'vue-property-decorator';
import { ValidationProvider } from 'vee-validate';

@Component({
  components: {
    ValidationProvider
  }
})
export default class QuasarValidator extends Vue {
  @PropSync('value', { type: [String, Number, Array, Object] })
  // eslint-disable-next-line
  syncedValue!: string | number | Array<any> | Object;

  @Prop({ default: '' })
  // eslint-disable-next-line
  qvValidate!: Record<string, any> | string;

  get required() {
    if (
      typeof this.qvValidate == 'string' &&
      this.qvValidate.includes('required')
    ) {
      return true;
    } else if (
      typeof this.qvValidate != 'string' &&
      this.qvValidate['required']
    ) {
      return this.qvValidate['required'];
    }
    return false;
  }
}
